export default {
  403: {
    title: '页面无权限',
    description: '请联系管理员',
  },
  404: {
    title: '页面未找到',
    description: '您访问的页面不存在，请检查 URL 是否正确或联系管理员。',
  },
  backToHome: '返回首页',
};
